// US Staging Environment Configuration
// Project: roboflow-staging
// Region: us-central1

module.exports = {
    env: "staging",
    region: "us",
    gcpRegion: "us-central1",
    gcpProjectId: "roboflow-staging",

    // Capability flags — controls which crons/integrations run in this environment
    bigQuery: { enabled: false },
    salesforce: { enabled: false },

    // Domain configuration
    urlDomain: "roboflow.one",
    cookieDomain: ".roboflow.one",

    // URLs
    urls: {
        app: "https://app.roboflow.one",
        public: "https://public.roboflow.one",
        public2: "https://public2.roboflow.one",
        universe: "https://universe.roboflow.one",
        rapid: "https://rapid.roboflow.one",
        rapidStreamApi: "https://us-central1-roboflow-staging.cloudfunctions.net/rapid-v2-server",
        models: "https://models.roboflow.one",
        api: "https://api.roboflow.one",
        admin: "https://admin.roboflow.one/",
        demo: "https://demo.roboflow.one",
        upload: "upload.roboflow.one",
        serverless: "https://serverless.roboflow.one",
        workflowAssistant: "https://us-central1-roboflow-staging.cloudfunctions.net/light-v2-query",
        dedicatedDeployments: "staging.roboflow.cloud"
    },

    // Inference endpoints
    inference: {
        classification: "https://serverless.roboflow.one",
        instanceSegmentation: "https://serverless.roboflow.one",
        semanticSegmentation: "https://lambda-semantic-segmentation.staging.roboflow.com",
        objectDetection: "https://serverless.roboflow.one",
        serverless: "https://serverless.roboflow.one",
        sam: "https://smartpoly.svc.roboflow.one/smartpoly/v2/inference",
        ritm: "https://smartpoly.svc.roboflow.one/smartpoly/v1/inference",
        autoLabel: "https://inference-internal.crusoe.roboflow.one",
        owlv2: "https://inference-internal.crusoe.roboflow.one/owlv2/infer",
        gpuWorkflow: "https://serverless.roboflow.one/workflows/run"
    },

    // Redis configuration
    redis: {
        billing: "10.88.148.156:6379",
        cache: "10.203.137.12:6379",
        flush: { host: "10.94.216.124", port: 6379 }
    },

    vpcConnector: "indexer-staging",

    // Spanner configuration
    spanner: { instanceId: "spanner-instance-staging" },

    // Firebase configuration
    firebase: {
        projectId: "roboflow-staging",
        projectNumber: "878913763597",
        appId: "1:878913763597:web:a3f48d2ca4084283475844",
        databaseURL: "https://roboflow-staging.firebaseio.com",
        storageBucket: "roboflow-staging-regional-sources",
        locationId: "us-central",
        apiKey: "AIzaSyA3dh8vzUpvpNX_LHpGXZNauXCnPgs7occ",
        authDomain: "app.roboflow.one",
        messagingSenderId: "878913763597",
        consoleUrl:
            "https://console.firebase.google.com/u/0/project/roboflow-staging/firestore/data/",
        appCheckSiteKey: "6LdsnFkpAAAAAMe1k9bn5ja5gbb4RBIgtu4Zu4-J"
    },

    // CDN configuration
    cdn: {
        source: "source.roboflow.one",
        repo: "repo.roboflow.one",
        userContent: "https://staging-usercontent.roboflowstatic.com",
        assets: "https://cdnassets.roboflow.one"
    },

    // Third-party services
    pusher: { appId: "iy92y09b" },
    intercom: {
        appId: "iy92y09b",
        sharedSupportAccountId: "7768950",
        teamIds: { growthSales: "8129885", selfServeSupport: "7809592" }
    },
    customerIo: { siteId: "47e7e677319868074330" },
    segment: { frontendWriteKey: "HBZHcbQpVRUB7cA1KNGMsrGy3rhX58GL" },
    posthog: { apiKey: "phc_7vHmsEBQdrH92qV7ePSX6xxaJPEP9GrZMt557NI5ZhV" },
    reddit: { appId: "a2_gknkiaps6sl9" },
    turnServer: { urls: "turn:turn1.roboflow.one:3478" },

    // BigQuery configuration
    bigQuery: {
        dataset: "roboflow_app_staging",
        workspace: "roboflow-staging.roboflow_app_staging_server",
        universeDatasetStats:
            "roboflow-platform.product_scheduled_query_results.staging_universe_dataset_stats"
    },

    // Model monitoring
    modelMonitoring: { apiUrl: "https://model-monitoring-apiservice-liwxmo5pvq-uc.a.run.app" },

    // Model evaluation
    modelEval: {
        dockerUri: "us-central1-docker.pkg.dev/roboflow-staging/model-eval/model-eval",
        roboflowApiUrl: "https://api.roboflow.one",
        roboflowAppUrl: "https://app.roboflow.one",
        objectDetectionInferenceEndpoint: "https://serverless.roboflow.one",
        asyncInferenceEndpoint: "https://serverless.roboflow.one"
    },

    // Buckets - keys are the aliases used by bucket() function
    buckets: {
        "train": "roboflow-staging-train",
        "cache": "roboflow-staging-cache",
        "sources": "roboflow-staging-regional-sources",
        "exports": "roboflow-staging-regional-exports",
        "transforms": "roboflow-staging-regional-transforms",
        "train-resume": "roboflow-staging-resume-training-files",
        "train-log": "com-roboflow-failed-train-logs-staging",
        "data-sharing": "data-sharing-staging",
        "embeddings": "roboflow-staging-embeddings",
        "weights-upload": "roboflow-staging-weights-upload",
        "videos": "roboflow-staging-videos",
        "core-models-tfjs": "roboflow-staging-core-models-tfjs",
        "usercontent": "roboflow-staging-usercontent",
        "iris-input-data": "roboflow-staging-iris-input-data",
        // Internal buckets (not used via bucket() alias)
        "core-models": "roboflow-staging-core-models",
        "trt-compilation": "roboflow-staging-trt-compilation",
        "autodistill": "com-roboflow-autodistill-staging",
        "fb-export": "roboflow-periodic-backups-staging",
        "data-staging": "roboflow-staging-data-staging",
        "batch-processing": "roboflow-staging-batch-processing",
        "goat-models-service-recovery": "roboflow-staging-model-registry-recovery",
        // upload bucket has a 7 day TTL policy
        "upload": "roboflow-staging-upload"
    },

    // Cloudflare R2
    r2: {
        coreModelsCache: "roboflow-staging-core-models-cache",
        endpoint: "https://core-models.roboflow.one"
    },

    // PubSub topics
    pubsub: {
        batchProcessing:
            "projects/rf-batch-staging/topics/roboflow-staging-batch-processing-events",
        dataStaging: "projects/rf-batch-staging/topics/roboflow-staging-image-shards-uploaded",
        goatModelsService: "projects/roboflow-staging/topics/goat-models_w_dlq"
    },

    // Device monitoring
    clickhouseDeviceMonitoring: { serviceId: "3049c8e5-c202-4d33-84cc-7fbd4e9abf26" },

    // Super admins
    superAdmins: [
        "eF616TpNiRbl6MniCL8FOD4rXX32", // Brad Dwyer, CTO
        "o4h8f4QDj3Vcp0cbtfqiWIKRKK73", // Joseph Nelson, CEO
        "EaIrqIKzQrWLXkNeZ7zOevsr17q1", // Sachin Agarwal, Infra Lead
        "ZZYYwu6mWTTX7NY9RRbEkIIKDQs1", // Kate Wagner, Ops Lead
        "zN8V4yvWZwRAROOUlERHejbC0tA3" // Shawn Adams, IT Specialist
    ],

    // Internal IPs
    internalServiceIPs: [
        // staging us-central1 v3
        "104.154.94.6",
        "34.41.38.81",
        "35.226.76.52",
        // dedicated us-central1 v1
        "34.31.100.121",
        "34.122.58.72"
    ],

    // Secrets references
    modelsServiceSecretRef: "projects/878913763597/secrets/MODELS_SERVICE_INTERNAL_SECRET",

    // Bucket mirror / sync config
    bucketMirror: {
        awsAccountId: "476357146257",
        gcpServiceAccount: "bucket-sync@roboflow-staging.iam.gserviceaccount.com",
        audience: "roboflow-staging",
        gcpAccessRoleArn: "arn:aws:iam::476357146257:role/rf-staging-bucket-sync-gcp-access",
        adminApiRoleArn: "arn:aws:iam::476357146257:role/rf-staging-bucket-sync-gcp-admin-api",
        apiEndpoint: "https://dcuhgyb77f.execute-api.us-east-1.amazonaws.com/staging",
        apiVpcEndpoint:
            "https://vpce-05d2e4fe3612b2ae8-2xscft7f.execute-api.us-east-1.vpce.amazonaws.com/staging",
        s3VpceId: "vpce-072840ddbfa4d7522",
        s3VpceDns: "bucket.vpce-072840ddbfa4d7522-v9xribd0.s3.us-east-1.vpce.amazonaws.com"
    },

    // Train clusters
    trainClusters: {
        "goog-us-central1": {
            k8sClusterName: "k8s-staging-v3",
            region: "us-central1",
            projectId: "roboflow-staging",
            hasSpot: true,
            hasOndemand: true,
            timeZone: "America/Chicago",
            location: "US",
            gpuTypes: ["t4"],
            gpuPrefer: { t4: 100 }
        },
        "goog-eu-west4": {
            k8sClusterName: "k8s-staging-eu-v3",
            region: "europe-west4",
            projectId: "roboflow-staging-eu",
            hasSpot: true,
            hasOndemand: true,
            timeZone: "Europe/Amsterdam",
            location: "EU",
            gpuTypes: ["t4"],
            gpuPrefer: { t4: 100 }
        },
        "crusoe-train": {
            k8sClusterName: "crusoe-train",
            region: "us-central1",
            projectId: "roboflow-staging",
            hasSpot: false,
            hasOndemand: true,
            timeZone: "America/Chicago",
            location: "US",
            crusoeRegistry:
                "registry.us-east1-a.ccr.crusoecloudcompute.com/roboflow-gcp-ar-mirror.61daf707"
        }
    },

    // Image suggestions dataset
    imageSuggestionsDataset: {
        workspaceId: "FVVkJB2vNZhxNczSPQGx0P93ZRr1",
        projectId: "zMa1LFwSzQsHwkoVYBRw"
    },

    // COCO model reference
    cocoModel: "coco-test/1",

    // YOLO-NAS COCO models
    yolonasCocoModels: {
        url: "microsoft-coco-obj-det",
        name: "MS COCO",
        owner: "FN0yEKLaCQ2GuQH48CvZ",
        type: "object-detection",
        versions: [
            {
                name: "Best",
                annotation: "Common Objects",
                modelType: "yolo_nas_s",
                tfjs: false,
                id: "5",
                results: { map: 0.522 }
            },
            {
                name: "Best",
                annotation: "Common Objects",
                modelType: "yolo_nas_m",
                tfjs: false,
                id: "6",
                results: { map: 0.54 }
            },
            {
                name: "Best",
                annotation: "Common Objects",
                modelType: "yolo_nas_l",
                tfjs: false,
                id: "7",
                results: { map: 0.487 }
            }
        ]
    },

    // Stripe configuration (full config)
    stripe: {
        publishableKey: "pk_test_vDJd8VmO7HZc8B6h0jCNAptE00rSMNQP0T",
        coupons: { opencv: "TJYNN79x" },
        products: {
            sourceImage: "price_1Gvna6JRyZoEkwsrU0Xe2XTO",
            generatedImage: "price_1GvnacJRyZoEkwsrLfmh2ZI0"
        },
        starterPlan: {
            productId: "prod_NUwbi9IdrEVD0J",
            priceId: "price_1MjwhvJRyZoEkwsrP7sn14La",
            annualPriceId: "price_1MjwnLJRyZoEkwsr9YsZvir7",
            expansionProductId: "prod_NxJjjUh651goW8",
            expansionPriceId: "price_1NBP6LJRyZoEkwsri2xLnxrX",
            expansionAnnualPriceId: "price_1NDukZJRyZoEkwsr76ORtokV",
            legacyProductId: "_",
            customExpansion: {
                images: {
                    productId: "prod_OFFvyvrVWDMuUe",
                    priceId: "price_1NSlPgJRyZoEkwsrthqRynyB",
                    upsellPriceId: "price_1NSlPgJRyZoEkwsrRUF8xR9g",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 19,
                    quantityPerUnit: 1000,
                    max: Infinity
                },
                inferences: {
                    productId: "prod_OFFy3aApSb08f6",
                    priceId: "price_1NbCjQJRyZoEkwsr2FrGJQ4D",
                    upsellPriceId: "price_1NbCkhJRyZoEkwsrpBE3XMAB",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 3,
                    quantityPerUnit: 1000,
                    max: Infinity
                },
                adminCollaborators: {
                    productId: "prod_OFG2a8tc94BvSU",
                    priceId: "price_1NSlWdJRyZoEkwsrwS5BNw5C",
                    upsellPriceId: "price_1NSlWdJRyZoEkwsrHfxPUvon",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 99,
                    quantityPerUnit: 1,
                    max: Infinity
                },
                trainCredits: {
                    productId: "prod_OFG54WVsWJPdTL",
                    priceId: "price_1NijUOJRyZoEkwsrBrLCv9y5",
                    upsellPriceId: "price_1PIe4jJRyZoEkwsrz2uR9fQd",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 60,
                    quantityPerUnit: 5,
                    max: Infinity
                },
                rbac: {
                    productId: "prod_OXCwZxoB0qjdBP",
                    priceId: "price_1NkSa1JRyZoEkwsrXVXBHLZg",
                    upsellPriceId: "price_1NkTGCJRyZoEkwsrByzQMpQQ",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 179,
                    quantityPerUnit: 1,
                    max: 1,
                    labelers: 5,
                    reviewers: 2
                }
            },
            offers: {
                oak: { priceId: "price_1OEhjHJRyZoEkwsrUxzpfSQJ", displayName: "OAK-D Lite" },
                outsourcedLabeling: {
                    priceId: "price_1OEhjuJRyZoEkwsrKDzHX4HX",
                    displayName: "Free Outsourced Labeling"
                },
                trainingCredits: {
                    priceId: "price_1OP8kxJRyZoEkwsrxzmZrSL1",
                    displayName: "30 Training Credits"
                }
            }
        },
        basicPlan: {
            productId: "prod_RCReiKt7YsfX8U",
            priceId: "price_1QKqE4JRyZoEkwsr1v90svDs",
            annualPriceId: "price_1QKqERJRyZoEkwsrQy8LVwmi"
        },
        corePlan: {
            productId: "prod_TWf0Mffe1hSmJu",
            priceId: "price_1SZbguJRyZoEkwsrDIh8zS3O",
            annualPriceId: "price_1SZbguJRyZoEkwsrwFrvvrNG",
            customExpansion: {
                adminCollaborators: {
                    productId: "prod_TX8v32dh92pWfi",
                    priceId: "price_1Sa4e7JRyZoEkwsrIo6XqBfd",
                    annualPriceId: "price_1Sc4o6JRyZoEkwsro0qEhnUr",
                    upsellDiscountPercent: 0,
                    pricePerUnit: 29,
                    quantityPerUnit: 1,
                    max: 7
                }
            }
        },
        growthPlan: {
            productId: "prod_RCRfDJ4EAIUm3P",
            priceId: "price_1QKqFQJRyZoEkwsry28Eo9MW",
            annualPriceId: "price_1QKqFoJRyZoEkwsr65fNbfP3"
        },
        autoLabel: {
            productId: "prod_Pm51cqMehMnLpF",
            default: [
                { priceId: "price_1OzN2SJRyZoEkwsrB541mZ3u", price: 15, credits: 500 },
                { priceId: "price_1OwswQJRyZoEkwsrIwbF4qIp", price: 29, credits: 1000 },
                { priceId: "price_1OwswvJRyZoEkwsrx5PyktZf", price: 129, credits: 5000 },
                { priceId: "price_1Owsx7JRyZoEkwsr5WKJkBZe", price: 249, credits: 10000 }
            ],
            starter: [
                { priceId: "price_1OwYe3JRyZoEkwsrAZDFdu3e", price: 49, credits: 2500 },
                { priceId: "price_1OwYeYJRyZoEkwsru0GLa6mL", price: 179, credits: 10000 },
                { priceId: "price_1OwYevJRyZoEkwsrOBG0vl2z", price: 349, credits: 25000 },
                { priceId: "price_1OwYf6JRyZoEkwsrWG7fYGwH", price: 599, credits: 50000 },
                { priceId: "price_1OwYfMJRyZoEkwsrOoEyGsvi", price: 999, credits: 100000 }
            ]
        },
        flexUsage: {
            hostedInferencesProductId: "prod_R0V9be1Wv6zzuW",
            hostedInferencesPriceId: "price_1Q8U9aJRyZoEkwsrhH6QEROz",
            roboflowCreditsProductId: "prod_REdfXECVONNUA0",
            roboflowCreditsMeterId: "mtr_test_61RHrroTof4RYXhyQ41JRyZoEkwsr1p2",
            roboflowPrepaidCreditsProductId: "prod_RbBSVqpryAoV3A"
        }
    },

    // Docs workspace
    docsWorkspaceId: null,

    // Sample dataset and large workspaces
    sampleDataset: "7I0RZYmP3u9yZgt4y28T",
    largeWorkspaces: ["MJSD3qwKcGesS9WMDZ4z"],

    // SFDC SAML SSO config
    sfdcSamlSso: {
        acsUrl: "https://roboflow1--staging.sandbox.my.site.com/supportvforcesite/login",
        spEntityId: "https://roboflow1--staging.sandbox.my.site.com/support",
        idpEntityId: "https://app.roboflow.one/query/sfdc-saml"
    },

    // Support config
    supportTeam: { id: "vQc6ThnzdwcmAjlxNoSZ" },
    supportUser: { id: "HurMd3PzDzUwL6PVID6ixDU0jg03", email: "help@roboflow.com" }
};
